/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentGraphValue = zod
  .object({
    booleanValue: zod.boolean().nullish(),
    dateValue: zod.string().nullish(),
    datetimeValue: zod.string().nullish(),
    jsonValue: zod
      .unknown()
      .optional()
      .describe(
        'Native JSON for `valueType: JSON` — arrays, objects and scalars are returned exactly as stored.',
      ),
    numericValue: zod.number().nullish(),
    stringValue: zod.string().nullish(),
  })
  .nullable();

export type ContentGraphValue = zod.input<typeof ContentGraphValue>;
export type ContentGraphValueOutput = zod.output<typeof ContentGraphValue>;
